import { Injectable } from '@angular/core';
import { RequestOptionsProvider } from '@cordic/request';
import { environment } from '../../../environments/environment';
import { AppConfigService } from '../app-config/app-config.service';

@Injectable({
  providedIn: 'root'
})
export class RequestOptionsProviderService implements RequestOptionsProvider {

  constructor(private appConfigService: AppConfigService){}

  get apiUrl()
  {
    const config = this.appConfigService.getConfig();

    if ((config) &&
        (config.urlChatMailWS))
    {
      return config.urlChatMailWS;
    }
    else if (environment.urlChatMailWS)
    {
      return environment.urlChatMailWS;
    }
  }

  get jwt()
  {
    return null;
  }
}
